"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINButtonStyle = exports.PINButton = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var types_1 = require("../../../types");
var PINButtonStyle;
(function (PINButtonStyle) {
    PINButtonStyle["mustaYellow"] = "mustaYellow";
    PINButtonStyle["nightBlack"] = "nightBlack";
    PINButtonStyle["coal"] = "coal";
    PINButtonStyle["nickel"] = "nickel";
    PINButtonStyle["success"] = "success";
    PINButtonStyle["warning"] = "warning";
    PINButtonStyle["info"] = "info";
    PINButtonStyle["failure"] = "failure";
    PINButtonStyle["snow"] = "snow";
})(PINButtonStyle || (PINButtonStyle = {}));
exports.PINButtonStyle = PINButtonStyle;
function PINButton(_a) {
    var color = _a.color, large = _a.large, small = _a.small, outline = _a.outline, inline = _a.inline, className = _a.className, children = _a.children, HTMLButtonProps = __rest(_a, ["color", "large", "small", "outline", "inline", "className", "children"]);
    var computedClassName = ("pinbutton " + color + (large ? " large" : "") + (small && !large ? " small" : "") + (outline ? " outline" : "") + (inline && !outline ? " inline" : "") + (className ? " " + className : ""));
    var childrenWithoutStrings = react_1.default.Children.map(children, function (child) { return (typeof child === "string"
        ? (react_1.default.createElement("div", null, child))
        : child); });
    return (react_1.default.createElement("button", __assign({}, HTMLButtonProps, { className: computedClassName }),
        react_1.default.createElement("div", { className: "pinbutton-content" }, childrenWithoutStrings)));
}
exports.PINButton = PINButton;
PINButton.propTypes = {
    color: prop_types_1.default.oneOf(Object.values(PINButtonStyle)).isRequired,
    large: prop_types_1.default.bool.isRequired,
    small: prop_types_1.default.bool.isRequired,
    outline: prop_types_1.default.bool.isRequired,
    /** Make the button outline */
    inline: prop_types_1.default.bool.isRequired,
    className: prop_types_1.default.string,
    children: types_1.ChildrenPropType,
};
PINButton.defaultProps = {
    color: PINButtonStyle.mustaYellow,
    large: false,
    small: false,
    outline: false,
    inline: false,
};
//# sourceMappingURL=PINButton.js.map